import React, { Component } from 'react';
import { Container, Row, Alert, Col } from 'reactstrap';
import { PropTypes } from 'prop-types';
import Footer from "./Footer";
import Sidebar from "./Sidebar";
import Header from "./Header";
import EnviarArquivos from '../Componente/Arquivos/EnviarArquivos';
import Feedback from '../Componente/Feedback/Feedback';
import Ajuda from '../Componente/Ajuda/Ajuda';
import TermosDeUso from "../Componente/TermosDeUso/TermosDeUso";
import Config from './../Util/config';
import HttpUtil from './../Util/httpUtil';
import { Link, withRouter } from 'react-router-dom';
import { LogsServiceAPI } from "../Util/logsService";
import Cookies from 'js-cookie';

// SignalR loaded via CDN in index.html — available as window.signalR
const signalR = window.signalR;


class Layout extends Component {

    constructor(props) {
        super(props);

        this.feedback = React.createRef();
        this.ajuda = React.createRef();

        this.state = {
            collapsed: false,
            modalUpload: false,
            modalFeedback: false,
            modalTermosDeUso: false,
            showSuccess: false,
            showError: false,
            errorMessage: "",
            successMessage: "",
            ambiente: window.location.href.indexOf("ec2-34-206-89-100.compute-1.amazonaws.com:9090"),
        };

        // verifica cookie e envia para a Api do log de acessos
        var logsServiceApi = new LogsServiceAPI();
 		logsServiceApi.salvarLog(Cookies.get('bG9naW4'), 355, 1);

        var idUsuario = localStorage.getItem("CodUsuario");

        this._connection = new signalR.HubConnectionBuilder()
            .withUrl(Config.urls.SIGNALR_HUB_URL)
            .withAutomaticReconnect()
            .build();

        this._connection.start().then(() => {
            this._connection.invoke('JoinGrupoUsuario', parseInt(idUsuario));
        });

        this._connection.on('Notificar', (data) => {

            if (data.length > 0 && window.location.href.indexOf("/arquivos-recentes") == -1) {
                var erro = data.filter((item) => {
                    return item.eTipoNotificacao == 'arquivoErro'
                });

                var sucesso = data.filter((item) => {
                    return item.eTipoNotificacao == 'arquivoSucesso'
                });

                var notifSucesso = sucesso.length == 0 ? '' : `${sucesso.length} arquivo${sucesso.length > 1 ? 's' : ''} ${sucesso.length > 1 ? 'foram' : 'foi'} ${sucesso.length > 1 ? 'enviados' : 'enviado'} com sucesso.`;
                var notifErro = erro.length == 0 ? '' : `${erro.length} arquivo${erro.length > 1 ? 's' : ''} ${erro.length > 1 ? 'apresentaram' : 'apresentou'} erros estruturais.`;

                if (notifErro != "" && this.state.errorMessage != notifErro) {
                    this.state.errorMessage = notifErro;
                    this.state.showError = false;
                    this.onDismissError();
                    this.informarLeitura(data, idUsuario);
                }

                if (notifSucesso != "" && this.state.successMessage != notifSucesso) {
                    this.state.successMessage = notifSucesso;
                    this.state.showSuccess = false;
                    this.onDismissSucess();
                    this.informarLeitura(data, idUsuario);
                }
            } else if (data.length > 0 && window.location.href.indexOf("/arquivos-recentes") > -1) {
                this.informarLeitura(data, idUsuario);
            }
        });

        this._connection.onreconnected(() => {
            this._connection.invoke('JoinGrupoUsuario', parseInt(idUsuario));
        });
    };

    componentWillUnmount() {
        if (this._connection) this._connection.stop();
    }

    onDismissSucess = () => {
        this.setState({
            showSuccess: !this.state.showSuccess
        });
    }

    onDismissError = () => {
        this.setState({
            showError: !this.state.showError
        });
    }

    onCollapse = () => {
        let active = !this.state.collapsed;
        this.setState({ collapsed: active });
    };

    toggleModalUpload = () => {
        if (localStorage.getItem("TermoUso") === "true")
            this.setState({ modalUpload: !this.state.modalUpload });
        else
            this.setState({ modalTermosDeUso: true });
    }

    modalFeedback = () => {
        this.feedback.current.toggleModalFeedback();
    }

    modalAjuda = () => {
        this.ajuda.current.modalAjudaHomol();
        //console.log("entrou no ajuda");
    }

    toggleModalTermosDeUso = () => {
        this.setState({ modalTermosDeUso: !this.state.modalTermosDeUso });
    };

    redirect = () => {
        this.props.history.push('/arquivos-recentes');
    }

    informarLeitura = (data, idUsuario) => {

        for (var i in data) {
            new Promise((resolve, reject) => {
                let url = `${Config.urls.API_URL_BASE}Notificacao/InformarLeitura/${idUsuario}/${data[i].idNotificacao}`;
                HttpUtil.eco_GET(url, (response) => { }, () => { console.log("Error"); });
            });
        }
    }

    render() {

        Container.propTypes = {
            fluid: PropTypes.bool
            // applies .container-fluid class
        };

        Row.propTypes = {
            noGutters: PropTypes.bool
        };

        return (
            <Container fluid={true} className="h-100">
                <div className="d-xs-block d-sm-block d-md-block d-lg-none">
                    <Header actionModalUpload={this.toggleModalUpload} />
                </div>
                <div id="sidebar" className={this.state.collapsed ? 'collapsed d-xs-none d-sm-none d-md-none d-lg-block' : ' d-xs-none d-sm-none d-md-none d-lg-block'}>
                    <Sidebar action={this.onCollapse} actionModalAjuda={this.modalAjuda} actionModalFeedback={this.modalFeedback} actionModalUpload={this.toggleModalUpload} origem={this.props.params.origem} />
                </div>
                <div id="main" className={this.state.collapsed ? 'collapsed' : ''}>
                    <main>
                        <Col>
                            {/* {this.state.ambiente > 0 ? <div class="alert alert-danger homolAlert" role="alert">Você está em ambiente de homologação!</div>
                                : <div class="alert alert-danger homolAlert" role="alert">ECF está liberado em versão beta! Clique <Link to={this.toggleModalTermosDeUso} onClick={this.toggleModalTermosDeUso} >aqui</Link> para maiores informações</div>} */}
                            {this.state.ambiente > 0 ? <div class="alert alert-danger homolAlert" role="alert">Você está em ambiente de homologação!</div>: null}
                            {/* <div class="alert alert-danger homolAlert" role="alert">Sistema temporariamente indisponivel.</div> */}
                        </Col>
                        <div className='alertsContainer'>
                            <Alert isOpen={this.state.showSuccess} toggle={this.onDismissSucess} color="success" className="notification">
                                <Container>
                                    <Row>
                                        <Col md={2}>
                                            <img src="/img/ecoicos/ecoico-sucesso.svg" />
                                        </Col>
                                        <Col md={10} onClick={this.redirect}>
                                            <p>{this.state.successMessage}</p>
                                            <p>Ir para Arquivos Recentes</p>
                                        </Col>
                                    </Row>
                                </Container>
                            </Alert>
                            <Alert isOpen={this.state.showError} toggle={this.onDismissError} color="danger" className="notification">
                                <Container>
                                    <Row>
                                        <Col md={2}>
                                            <img src="/img/ecoicos/ecoico-alerta.svg" />
                                        </Col>
                                        <Col md={10} onClick={this.redirect}>
                                            <p>{this.state.errorMessage}</p>
                                            <p>Ir para Arquivos Recentes</p>
                                        </Col>
                                    </Row>
                                </Container>
                            </Alert>
                        </div>
                        {this.props.children}
                    </main>
                    <Footer />
                </div>
                <EnviarArquivos propModalUpload={this.state.modalUpload} fnToggleModalUpload={this.toggleModalUpload} />
                <Feedback propModalFeedback={this.state.modalFeedback} ref={this.feedback} />
                <Ajuda ref={this.ajuda} />
                <TermosDeUso modalOpen={this.state.modalTermosDeUso} toggleModal={this.toggleModalTermosDeUso} />
            </Container>
        )
    }
}

export default withRouter(Layout);



// WEBPACK FOOTER //
// ./src/Layout/Layout.jsx